import axios from 'axios'

export default () => {
    return axios.create({
        withCredentials: true,
        baseURL: 'https://codenote.onrender.com/users',
    })
}